import { motion } from "framer-motion";

import Home from "../screens/home";
import Projects from "../screens/projects";
import About from "./about";
import MySkills from "./about/Skills";
import CuriousStuffs from "./curious";
import Experiences from "./about/Experiences";

const revealTransition = {
  duration: 0.72,
  ease: [0.22, 1, 0.36, 1],
};

function RevealSection({ children }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 34 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.22 }}
      transition={revealTransition}
      style={{ width: "100%" }}
    >
      {children}
    </motion.div>
  );
}

export default function Screens() {
  return (
    <>
      <Home />
      <div
        className="wrap"
        style={{ display: "flex", flexDirection: "column", gap: "50px" }}
      >
        <RevealSection>
          <About />
        </RevealSection>
        <RevealSection>
          <MySkills />
        </RevealSection>
        <RevealSection>
          <Experiences />
        </RevealSection>
        <RevealSection>
          <Projects />
        </RevealSection>
        <RevealSection>
          <CuriousStuffs />
        </RevealSection>
      </div>
    </>
  );
}
